import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
// import NotFound from '../../pages/utils/404';
const Dashboard = lazy(() => import('../../pages/admin/dashboard'));

const DashboardRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={Dashboard} />
      {/* <Route component={NotFound} /> */}
    </Switch>
  );
};

export default DashboardRoutes;
